const initialState = "";

const token = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_TOKEN':
            state = action.payload.token
            return state;

        default:
            return state;
    }
};

export default token;